<template>
  <div>
    <NavbarSection />

    <!-- Hero Video Section -->
    <section class="w-full relative bg-center bg-cover md:!h-screen pt-12 md:pt-0 overflow-hidden" id="home">
      <div class="absolute inset-0 z-0">
        <video id="bg-video" autoplay muted class="w-full h-full object-cover" loop playsinline preload="auto">
          <source :src="video" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
        <!-- Cinematic overlay -->
        <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>
      </div>

      <!-- Floating particles -->
      <div class="absolute inset-0 z-10 pointer-events-none overflow-hidden">
        <div v-for="i in 12" :key="i" class="particle" :style="particleStyle(i)"></div>
      </div>

      <!-- Hero Content -->
      <div class="container relative z-20 h-full flex items-center justify-center min-h-screen">
        <div class="text-center text-white px-4">
          <h1 class="hero-title animate-fade-up md:text-6xl text-4xl font-bold leading-tight mb-6 text-white drop-shadow-xl">
            Sultan Flowers<br>
            <span class="text-gradient">Extract Palace</span>
          </h1>
          <div class="animate-bounce-in flex flex-wrap justify-center gap-4">
            <a href="javascript:void(0);" @click="scrollToSection('#about')"
               class="hero-btn-primary group inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-orange-600/40">
              <span>Discover Our Story</span>
              <i class="uil uil-arrow-right group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a href="javascript:void(0);" @click="scrollToSection('#review')"
               class="hero-btn-secondary inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-300 hover:scale-105">
              <i class="uil uil-star"></i>
              <span>Leave a Review</span>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- End -->
    <AboutSection />
    <ServiceSection />
    <YoutubeVideos />
    <ReviewForm />
    <ReviewSection />
    <Gallery v-if="!usersImagesLoading"></Gallery>
    <FooterSection />
    <SwitcherSection />
  </div>
  <Toast />
</template>

<script setup>
import NavbarSection from '../components/NavbarSection.vue';
import AboutSection from '../components/AboutSection.vue';
import ServiceSection from '../components/ServiceSection.vue';
import ReviewSection from "@/components/ReviewSection.vue";
import ReviewForm from '../components/ReviewForm.vue';
import FooterSection from '../components/FooterSection.vue';
import SwitcherSection from '../components/SwitcherSection.vue';
import store from "@/store";
import { computed, onMounted } from "vue";
import Gallery from "@/components/Gallery.vue";
import YoutubeVideos from "@/components/Youtube-videos.vue";
import video from "../assets/images/video/video.mp4"

const usersImagesLoading = computed(() => store.state.usersImages.loading)

const particleStyle = (i) => {
  const size = Math.random() * 6 + 2;
  const x = Math.random() * 100;
  const delay = Math.random() * 8;
  const duration = Math.random() * 10 + 8;
  const opacity = Math.random() * 0.5 + 0.1;
  return {
    width: `${size}px`,
    height: `${size}px`,
    left: `${x}%`,
    animationDelay: `${delay}s`,
    animationDuration: `${duration}s`,
    opacity: opacity,
    background: i % 3 === 0 ? '#ea580c' : i % 3 === 1 ? '#fff' : '#fbbf24',
    borderRadius: '50%',
    position: 'absolute',
    top: '110%',
    animation: `floatUp ${duration}s ${delay}s infinite linear`,
  }
}

const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

onMounted(() => {
  store.dispatch('getUsersImages')
})
</script>

<style scoped>
/* Hero text gradient */
.text-gradient {
  background: linear-gradient(135deg, #ea580c, #f59e0b, #ea580c);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 3s linear infinite;
}

@keyframes shimmer {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

/* Particle float animation */
@keyframes floatUp {
  0% { transform: translateY(0) rotate(0deg); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 0.6; }
  100% { transform: translateY(-110vh) rotate(720deg); opacity: 0; }
}

/* Hero fade animations */
.animate-fade-down {
  animation: fadeDown 0.9s ease-out both;
}
.animate-fade-up {
  animation: fadeUp 1s ease-out 0.2s both;
}
.animate-fade-up-delay {
  animation: fadeUp 1s ease-out 0.5s both;
}
.animate-bounce-in {
  animation: bounceIn 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s both;
}

@keyframes fadeDown {
  from { opacity: 0; transform: translateY(-20px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes bounceIn {
  from { opacity: 0; transform: scale(0.7); }
  60%  { transform: scale(1.05); }
  80%  { transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
}

/* Scroll bounce indicator */
.animate-scroll-bounce {
  animation: scrollBounce 2s ease-in-out infinite;
}
@keyframes scrollBounce {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50%       { transform: translateX(-50%) translateY(8px); }
}
</style>